import { jsx } from 'react/jsx-runtime';
import { LottieIcon } from '../../LottieIcon/LottieIcon.es.js';

const SelectListLoading = (props)=>{
    return jsx("div", {
        className: "select-list-loading",
        ...props,
        children: jsx(LottieIcon, {
            height: 65,
            name: "LoadingSpinner",
            width: 65,
            loop: true
        })
    });
};
SelectListLoading.displayName = 'SelectList.Loading';

export { SelectListLoading };
//# sourceMappingURL=SelectList.Loading.es.js.map
